export enum UserStatus {
  User = 'user',
  Support = 'support',
  Admin = 'admin',
  SuperAdmin = 'super-admin',
}
